import { Inbox } from "@novu/react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { NotificationIcon } from "../../Icons/Notification";
import "./style.scss";

export function NotificationCenter() {
  const navigate = useNavigate();
  const userInfo = useSelector((state: any) => state.user.user);

  if (!userInfo?.id) return null; // Prevent rendering without a subscriber

  return (
    <Inbox
      applicationIdentifier={process.env.REACT_APP_NOVU_APP_ID as string}
      backendUrl={process.env.REACT_APP_NOVU_BACKEND_URL}
      socketUrl={process.env.REACT_APP_NOVU_SOCKET_URL}
      routerPush={(path: string) => navigate(path)}
      renderBell={(num) => (
        <div className="header-notification">
          <NotificationIcon />
          {<span>{num > 0 ? num : 0}</span>}
        </div>
      )}
      subscriber={userInfo.id?.toString()}
      placement="bottom-start"
    />
  );
}
